import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      width: '100%',
      background: theme.palette.secondary.light,
      [theme.breakpoints.up('md')]: {
        width: 900,
      },
      '&:focus': {
        outline: 'none',
      },
    },
    headerWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: SMALL_MARGIN,
    },
    title: {
      fontSize: 24,
      lineHeight: 1.2,
      fontWeight: 'bold',
      [theme.breakpoints.up('md')]: {
        fontSize: 28,
      },
    },
    description: {
      fontSize: 18,
      fontWeight: 22,
    },
    closeIcon: {
      width: 14,
      height: 14,
      cursor: 'pointer',
    },
    shareButton: {
      width: 185,
      cursor: 'pointer',
      marginBottom: 6,
      '&:last-child': {
        marginBottom: 0,
      },
    },
    list: {
      margin: `${SMALL_MARGIN}px 0 0`,
      padding: 0,
      listStyle: 'none',
    },
    listItem: {
      display: 'flex',
      alignItems: 'center',
      padding: `${SMALL_MARGIN}px 0`,
      fontSize: 16,
      lineHeight: 1.5,
      '&:last-child': {
        padding: `${SMALL_MARGIN}px 0 0 0`,
      },
      '&:not(:last-child)': {
        borderBottom: `1px solid ${fade(colorsPalette.blue, 0.33)}`,
      },
    },
    listCounter: {
      fontSize: 28,
      lineHeight: '34px',
      color: colorsPalette.blue,
      marginRight: SMALL_MARGIN,
      fontWeight: 700,
    },
  }),
);

export default useStyles;
